"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationConflictResolver = exports.ConfigurationConflict = void 0;
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
var ConfigurationConflict;
(function (ConfigurationConflict) {
    ConfigurationConflict["leitungAussendurchmesserTooSmallForKette"] = "LeitungAussendurchmesserTooSmallForKette";
    ConfigurationConflict["ketteRTooBigForLeitung"] = "KetteRTooBigForLeitung";
    ConfigurationConflict["ketteRBRTooBigForLeitung"] = "ketteRBRTooBigForLeitung";
    ConfigurationConflict["leitungTooShortForKette"] = "leitungTooShortForKette";
    ConfigurationConflict["leitungTooShortForKetteWithAEs"] = "leitungTooShortForKetteWithAEs";
})(ConfigurationConflict = exports.ConfigurationConflict || (exports.ConfigurationConflict = {}));
class ConfigurationConflictResolver {
    static getLeitungConflicts(configuration, leitung) {
        if (!leitung)
            return [];
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configuration.toModel());
        switch (type) {
            case 'Empty':
            case 'EspoolChild':
                return [];
            case 'Kette': {
                const kette = config.Kette;
                return this.getLeitungConflictsForKette(kette, leitung);
            }
            case 'Espool': {
                const espoolModel = config.Espool;
                return this.getLeitungConflictsForEspool(espoolModel, leitung);
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    static getLeitungConflictsForKette(kette, leitung) {
        const conflicts = [];
        if (this.leitungAussendurchmesserTooSmallForKette(leitung, (0, echain_shared_articles_oo_1.A)(kette)))
            conflicts.push(ConfigurationConflict.leitungAussendurchmesserTooSmallForKette);
        if (this.ketteRTooBigForLeitung((0, echain_shared_articles_oo_1.A)(kette), leitung))
            conflicts.push(ConfigurationConflict.ketteRTooBigForLeitung);
        if (this.ketteRBRTooBigForLeitung((0, echain_shared_articles_oo_1.A)(kette), leitung))
            conflicts.push(ConfigurationConflict.ketteRBRTooBigForLeitung);
        if (this.leitungTooShortForKette(leitung, (0, echain_shared_articles_oo_1.A)(kette)))
            conflicts.push(ConfigurationConflict.leitungTooShortForKette);
        if (this.leitungTooShortForKetteWithAEs(leitung, (0, echain_shared_articles_oo_1.A)(kette)))
            conflicts.push(ConfigurationConflict.leitungTooShortForKetteWithAEs);
        return conflicts;
    }
    static getLeitungConflictsForEspool(espoolModel, leitung) {
        const conflicts = [];
        const espool = (0, echain_shared_articles_oo_1.A)(espoolModel);
        const result = espool.canLeitungenLayIn([leitung])[0];
        if (!result.aussendurchmesserCheck) {
            conflicts.push(ConfigurationConflict.leitungAussendurchmesserTooSmallForKette);
        }
        if (!result.biegeradiusCheck) {
            conflicts.push(ConfigurationConflict.ketteRTooBigForLeitung);
        }
        if (!result.leitungsLaengeCheck) {
            conflicts.push(ConfigurationConflict.leitungTooShortForKette);
        }
        return conflicts;
    }
    static leitungAussendurchmesserTooSmallForKette(leitung, kette) {
        return !!leitung && !!kette && kette.canLayLeitung(leitung).aussendurchmesser === false;
    }
    static ketteRTooBigForLeitung(kette, leitung) {
        return !!leitung && !!kette && kette.canLayLeitung(leitung).biegeradius === false;
    }
    static ketteRBRTooBigForLeitung(kette, leitung) {
        return !!leitung && !!kette && kette.canLayLeitung(leitung).rbr === false;
    }
    static leitungTooShortForKette(leitung, kette) {
        return (!!leitung &&
            !!kette &&
            !!kette.effektiveLaenge &&
            !echain_shared_articles_1.LeitungCalculator.isLeitungAndUeberstandValid(leitung.leitungslaenge, leitung.ueberstandMitnehmer || leitung.ueberstandFestpunkt, kette.effektiveLaenge));
    }
    static leitungTooShortForKetteWithAEs(leitung, kette) {
        return (!!leitung &&
            !!kette &&
            !!kette.effektiveLaengeWithAEs &&
            !echain_shared_articles_1.LeitungCalculator.isLeitungAndUeberstandValid(leitung.leitungslaenge, leitung.ueberstandMitnehmer || leitung.ueberstandFestpunkt, kette.effektiveLaengeWithAEs));
    }
}
exports.ConfigurationConflictResolver = ConfigurationConflictResolver;
//# sourceMappingURL=ConfigurationConflictResolver.js.map